import {
  useGetClientByIdQuery,
  useGetIndividualProgramsQuery,
} from '@entities/clients/rtk-query.ts';
import { useState } from 'react';

export const useLoadPrograms = (id: number, code: string) => {
  const [page, setPage] = useState(1);

  // const { module } = useModule(code);

  const { data: client, isLoading: isClientLoading } = useGetClientByIdQuery(id);

  const { data: individualPrograms, isLoading: isIndividualProgramsLoading } =
    useGetIndividualProgramsQuery(
      {
        clientId: client?.id as number,
        page: page,
        // module: module?.id,
      },
      { skip: isClientLoading || !client }
    );

  return {
    loading: isClientLoading || isIndividualProgramsLoading,
    programs: individualPrograms?.results || [],
    hasNextPage: Boolean(individualPrograms?.next),
    loadMore: () => setPage(page + 1),
  };
};
